import React, { ReactNode } from "react";

type SubmitOnEnterKeyPressProps = {
  children: ReactNode;
}

export const SubmitOnEnterKeyPress = ({ children }: SubmitOnEnterKeyPressProps) => {
  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (
      event.key === "Enter" &&
      !event.shiftKey &&
      (event.target instanceof HTMLInputElement ||
        event.target instanceof HTMLTextAreaElement ||
        event.target instanceof HTMLSelectElement)
    ) {
      event.preventDefault();
      event.stopPropagation();

      const submitButton = event.currentTarget.querySelector('button[type="submit"]');
      if (submitButton instanceof HTMLButtonElement) {
        submitButton.click();
      }
    }
  };

  return <div onKeyDown={handleKeyDown}>{children}</div>;
};
